import { AVAILABLE_QUANTITY } from '../cols/DatesCol/DatesCell/EditPeriods/DatePickerPeriodSelector/hooks/useInventoryPeriods'

export const isPeriodsInventoryValid = (periods, selectedQuantity) => {
  // check if available inventory enough for all periods
  return periods.every(period => period[AVAILABLE_QUANTITY] >= selectedQuantity)
}
